import {
  proxyServer
} from './connection';

//connect.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

export const getLead = leadId => {
  return async () => {
    return await proxyServer.get(`/coop/leads/${leadId}`);
  };
};

export const postLead = formValues => {
  return async () => {
    return await proxyServer.post('/coop/leads/', formValues);
  };
};

export const putLead = (id, formValues) => {
  return async () => {
    return await proxyServer.put('/coop/leads/', Object.assign({}, formValues, {
      id: id
    }));
  };
};

export const getEmail = email => {
  return async () => {
    return await proxyServer.get(`/coop/leads?search=email&email=${email}`);
  };
};

export const getUUID = email => {
  return async () => {
    return await proxyServer.get(`/coop/lead?search=email&email=${email}`);
  };
};

export const getDBAPDF = async (values) => {
  const url = process.env.REACT_APP_DBA_PDF_URL;
  return await fetch(url).then(res => res.arrayBuffer());
};
